function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import getWindow from "./getWindow.js";
function isElement(node) {
    var OwnElement = getWindow(node).Element;
    return _instanceof(node, OwnElement) || _instanceof(node, Element);
}
function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return _instanceof(node, OwnElement) || _instanceof(node, HTMLElement);
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
        return false;
    }
    var OwnElement = getWindow(node).ShadowRoot;
    return _instanceof(node, OwnElement) || _instanceof(node, ShadowRoot);
}
export { isElement, isHTMLElement, isShadowRoot };
